module.exports = __webpack_public_path__ + "img/logistics-logo.f0b6cf1d.svg";